import Head from 'next/head'
import AboutTemplate from '~/components/templates/AboutTemplate'

const About = () => {
  return (
    <>
      <Head>
        <title>事業者概要・個人情報保護指針 | eduad</title>
        <meta
          name='description'
          content='eduad-エデュアド-は教育・スクール運営に特化したウェブマーケティング支援を行うプロフェッショナル技術者集団です。事業者情報・プライバシーポリシーについてご紹介いたします。'
        />
      </Head>
      <div>
        <AboutTemplate />
      </div>
    </>
  )
}

export default About
